<template>
  <svg data-icon-name="youtube" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.443 26" fill="none" stroke="#000a12" stroke-width="1.5"><path d="M35.1 4.628a4.41 4.41 0 0 0-3.063-3.062C29.281.8 18.256.8 18.256.8S7.384.8 4.628 1.566a4.41 4.41 0 0 0-3.062 3.062C1.008 7.399.751 10.223.8 13.05a39.19 39.19 0 0 0 .766 8.422 4.41 4.41 0 0 0 3.062 3.062c2.756.766 13.628.766 13.628.766s11.025 0 13.628-.766a4.41 4.41 0 0 0 3.062-3.062 52.19 52.19 0 0 0 .766-8.422 39.02 39.02 0 0 0-.612-8.422z"/><path d="M23.856 13.094l-9.187-5.206v10.565z"/></svg>
</template>

<script>
import {
  defineComponent,
} from 'vue';

export default defineComponent({});
</script>
